<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route Wizard</ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <!-- <pre>{{ vm.pendingTickets | json }}</pre> -->
    <ion-list-header color="secondary" data-test="listHeader">
        Pending Ticket Selection - (Step 2 of 8)
    </ion-list-header>

    <ion-list>
        <ion-item-divider color="tertiary">
            Dropoff Tickets
        </ion-item-divider>
        @for (ticket of dropoffTickets; track $index) {
        <ion-item [disabled]="vb.disabled" data-test="dropoffTickets">
            <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                <!-- <strong>Created: {{formatDate(ticket.createdDate)}}</strong><br /> -->
                <strong>Created: {{ticket.createdDate | myTimestamp:'EEEE, MMMM do yyyy, hh:mm:ss a'}}</strong><br />
                {{ticket.passengerName}}{{ticket.numPassengersStr}}<br />
                Location: {{ticket.dropoff.locationName}}<br />
                Address: {{ticket.dropoff.address.fullAddress}}<br />
                Note: {{ticket.note}}
            </ion-label>
            <ion-checkbox data-test="dropoffTicketCheckbox" slot="end" (ionChange)="onTicketSelectedClick(ticket)" [(ngModel)]="ticket.selected">
            </ion-checkbox>
        </ion-item>
        }

        <ion-item-divider color="tertiary">
            Pickup Tickets
        </ion-item-divider>
        @for (ticket of pickupTickets; track $index) {
        <ion-item [disabled]="vb.disabled" data-test="pickupTickets">
            <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                <!-- <strong>Created: {{formatDate(ticket.createdDate)}}</strong><br /> -->
                <strong>Created: {{ticket.createdDate | myTimestamp:'EEEE, MMMM do yyyy, hh:mm:ss a'}}</strong><br />
                {{ticket.passengerName}}{{ticket.numPassengersStr}}<br />
                Location: {{ticket.pickup.locationName}}<br />
                Address: {{ticket.pickup.address.fullAddress}}<br />
                Note: {{ticket.note}}
            </ion-label>
            <ion-checkbox data-test="pickupTicketCheckbox" slot="end" (ionChange)="onTicketSelectedClick(ticket)" [(ngModel)]="ticket.selected">
            </ion-checkbox>
        </ion-item>
        }

    </ion-list>
</ion-content>

<ion-footer>
    <ion-item-divider color="tertiary">
        Available Seats
    </ion-item-divider>
    <ion-list lines="none" data-test="availableSeats">
        <ion-item color="info" class="infoMsg">
            <ion-label class="ion-text-wrap">
                Shuttle Passenger Capacity: &nbsp; {{vm.selectedShuttle.passengerCapacity}}<br />
                Seats Still Available For Dropoff: &nbsp; {{vm.dropoffManifest.seatsAvailable}}<br />
                Seats Still Available For Pickup: &nbsp; {{vm.pickupManifest.seatsAvailable}}
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Next" (click)="onNextClick()" data-test="routeNext2">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>